import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { css } from 'styled-components';
export default css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n  outline: none;\n  padding: 8px 0;\n  position: absolute;\n  z-index: 1;\n"])));